var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-40 p-4 border border-solid border-grey-200 rounded-lg flex flex-col bg-white"},[_c('div',{staticClass:"flex h-16 text-sm text-grey-600"},[_vm._t("header")],2),_c('div',{staticClass:"flex flex-grow text-grey-800 text-5xl"},[_vm._t("content")],2),_c('div',{staticClass:"flex h-10"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }